import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Task } from '../model/bpmn/task';

@Injectable({
    providedIn: 'root'
  })
  export class BpmnTaskService{
  
    constructor(private _restClientService : RestClientService) 
    {}

    findCurrentTasksByRequestInstanceId(processInstancesId) 
    {
        return this._restClientService.load<Task[]>('bpmn/tasks/find-current-tasks-by-requestinstanceid/'+processInstancesId);
    }
    
  
}